import SearchResults from './SearchResults';

export default function SearchTestSeries() {
  return <SearchResults categoryId={0} />;
}
